// Replay constants that can be used on client and server

export const DIMENSIONS = {
  width: 540,
  height: 960,
};

/** Quality of the video transform by imagekit. Should be 60 or less ideally. */
export const VIDEO_QUALITY = 45;
